<template>
  <div :style="{height: watchHeight + 'px'}">
    <Form style="margin: 20px" :model="formItem" :label-width="120" label-position="left">
      <div class="formRow">
        <div class="formCol">
          <FormItem label="问题">
            <Input v-model="formItem.question"/>
          </FormItem>
        </div>
        <div class="formCol">
          <FormItem label="是否完成问答">
            <Select v-model="formItem.questionStatus" clearable placeholder="">
              <Option v-for="item in List" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
        </div>
        <div class="formCol">
          <Button @click="searchQA" style="margin-right:30px"><!-- 检索 -->{{$t('Search')}}</Button>
          <Button @click="addQA">新增问题</Button>
        </div>
      </div>
    </Form>
    <ul v-if="data.length">
      <li v-for="(item, i) in data" :key="i" style="line-height:2em;margin-left:12px">
        <h3 style="margin:20px 0;">{{i+1}}、{{ item.question }} <Button v-if="item.questionStatus==0" @click="giveAnswer(item)">回答问题</Button></h3> 
        <p style="text-indent:2em;"><span v-if="item.answers">答：</span>{{ item.answers }}</p>
      </li>
    </ul>
    <Modal v-model="questionPerson" title='新增问题' width=500px>
      <Form inline label-position="left">
        <FormItem label="问题" :label-width="100" style="margin-top:15px" v-if="questionPerson">
          <Input type="textarea" :rows="5" v-model="questionPersonItem.question" style="width:320px"></Input>
        </FormItem>
      </Form> 
      <div slot="footer">
        <Button type="text" @click="handleConfirm">确认</Button>           
        <Button type="text" @click="handleCancle">取消</Button>        
      </div>
    </Modal>
    <Modal v-model="answerPerson" title='回答问题' width=500px>
      <Form inline label-position="left">
        <FormItem label="回答" :label-width="100" style="margin-top:15px" v-if="answerPerson">
          <Input type="textarea" :rows="5" v-model="questionPersonItem.answers" style="width:320px"></Input>
        </FormItem>
      </Form> 
      <div slot="footer">          
        <Button type="text" @click="handleConfirm2">确认</Button>           
        <Button type="text" @click="handleCancle2">取消</Button>           
      </div>
    </Modal>



    <!-- <Card style="margin-top: 20px"> -->
      <!-- <Table border stripe ref="table" :loading="loading" :columns="columns" :data="data"  highlight-row> </Table> -->
      <Row style="margin-top:15px" v-show="false">
        <Col span="19">
          <Page :total="total" :page-size="pageInfo.pageSize" @on-change="pageChange"/>
        </Col>
      </Row>
    <!-- </Card> -->
  </div>
</template>

<script>
import axios from 'axios'
import DateUtil from '@/util/DateUtil'
// import expandRow from './table-expand.vue';
export default {
  // components: { expandRow },
  data() {
    return {
      date:new DateUtil(),
      loading:false,
      List:[
        {
          value:"1",
          label:"是",
        },
        {
          value:"0",
          label:"否",
        },
      ],
      columns:[
        {
            type: 'expand',
            width: 50,
            render: (h, params) => {
                return h(expandRow, {
                    props: {
                        row: params.row
                    }
                })
            }
        },
        {
            title: '问题',
            key: 'question',
            align:'center',
        },
        // {
        //     title: '提问人id',
        //     key: 'questionUserId',
        //     align:'center',
        // },
        {
            title: '提问人姓名',
            key: 'questionUserName',
            align:'center',
        },
        {
            title: '提问时间',
            key: 'questionDate',
            align:'center',
            render: (h, params) => {
                  return h(
                  "span",
                  this.date.dateVal(params.row.questionDate, "YYYY-MM-DD")
                  );
              },
        },
        // {
        //     title: '回答',
        //     key: 'answers',
        //     align:'center',
        // },
        // {
        //     title: '回答人id',
        //     key: 'answersUserId',
        //     align:'center',
        // },
        // {
        //     title: '回答人姓名',
        //     key: 'answersUserName',
        //     align:'center',
        // },
        // {
        //     title: '回答时间',
        //     key: 'answersDate',
        //     align:'center',
        //     render: (h, params) => {
        //           return h(
        //           "span",
        //           this.date.dateVal(params.row.answersDate, "YYYY-MM-DD")
        //           );
        //       },
        // },
        {
            title: '是否完成问答',
            key: 'questionStatus',
            align:'center',
            render: (h,params)=>{
            let questionStatus1 = params.row.questionStatus
            if(questionStatus1==1){ questionStatus1 = "是"}
            else{ questionStatus1 = "否"}
            return h("span", questionStatus1);
          },
        },
      ],
      data:[],
      formItem:{},
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10,
      },
      total:1,
      count:1,
      questionPerson:false,
      questionPersonItem:{},
      answerPerson:false,
      idNumber:null,
      watchHeight:600,
    }
  },
  created(){
    this.searchQA()
    this.watchHeight = document.documentElement.scrollHeight
  },
  methods: {
    searchQA(){
      let obj = {
        ...this.formItem,
        pageNo : this.pageInfo.pageNo,
        pageSize : this.pageInfo.pageSize,
      }
      axios.post("/question/selectQuestionAndAnswers", obj).then((res) => {
        this.data = res.data
        // this.data[0]._expanded = true  //默认展示第一行
      })
    },
    pageChange(){

    },
    addQA(){
      this.questionPerson = true
    },
    handleConfirm(){
      this.questionPerson = false
      let questionUserId = JSON.parse( sessionStorage.getItem('userInfo') ).userId,
          questionUserName = JSON.parse( sessionStorage.getItem('userInfo') ).userName
      let obj = {
        question : this.questionPersonItem.question,
        questionUserId : questionUserId,
        questionUserName : questionUserName,
      }
      axios.post("/question/insertQuestionInfo", obj).then((res) => {
        questionUserId = ''
        questionUserName = ''
        this.questionPersonItem.question = ''
        this.searchQA()
      })
    },
    handleCancle(){
      this.questionPerson = false
    },

    giveAnswer(item){
      this.answerPerson = true
      this.idNumber = item.id
    },
    handleConfirm2(){
      this.answerPerson = false
      let answersUserId = JSON.parse( sessionStorage.getItem('userInfo') ).userId,
          answersUserName = JSON.parse( sessionStorage.getItem('userInfo') ).userName
      let obj = {
        answers : this.questionPersonItem.answers,
        answersUserId : answersUserId,
        answersUserName : answersUserName,
        id: this.idNumber
      }
      axios.post("/question/updateQuestionInfo", obj).then((res) => {
        this.questionPersonItem.answers = ''
        this.searchQA()
      })
    },
    handleCancle2(){
      this.answerPerson = false
    }
  },
};
</script> 

<style scoped>
  ul,li { 
    padding:0;
    margin:0;
    list-style:none
  }
  .formRow {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .formCol {
    width: calc((100% - 210px) / 3);
    float: left;
    margin-right: 30px;
  }
  @media screen and (max-width: 640px) {
    .formCol {
        width: 100%;
        margin-right: 0px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/index/QuestionAndAnswers.vue